module.exports = __webpack_public_path__ + "media/categories/7016-c1f56576.svg";